import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Course } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps } from '@shapeable/ui';
import { VERY_LIGHT_BROWN } from '../../theme';
import { EntityCuratorFootMeta } from './entity-curator-foot-meta';
const cls = classNames('course-curator-card');

// -------- Types -------->

// -------- Props -------->

export type CourseCuratorCardProps = EntityCardProps & { 
  entity?: Course;
};

export const CourseCuratorCardDefaultProps: Omit<CourseCuratorCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 5,
  showDescription: true,
  showTypeHeader: false,
  showDescriptionDivider: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const FootMetaStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    FootMeta: styled(EntityCuratorFootMeta)`${FootMetaStyles}`,
};

export const CourseCuratorCard: Shapeable.FC<CourseCuratorCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  return (
    <My.Container 
      {...cardProps}
      entity={entity}
      showDescription={true}
      useLink={false}
      imageProps={{ showIcon: false }}
      showDescriptionDivider={false}
      className={cls.name(className)}
      colors={{ background: VERY_LIGHT_BROWN }}
      foot={
        <My.FootMeta entity={entity} />
      }
    />
  )
};

CourseCuratorCard.defaultProps = CourseCuratorCardDefaultProps;
CourseCuratorCard.cls = cls;